<template>
  <DialogWrapper
    close-on-cancel
    destroyOnClose
    class="ai-comparison-select-job-dialog"
    :titleI18nKey="`${i18nPrefix}.title.aiTalentPoolRecommenderSelectJobTitle`"
    :loading="isLoading"
    :show.sync="isShow"
  >
    <div class="select-job-content">
      <span class="label">{{ $t(`${i18nPrefix}.label.aiTalentPoolRecommenderJob`) }}</span>
      <el-select v-model="selectJobId" filterable class="job-select">
        <el-option
          v-for="(job, index) in jobList"
          :key="index"
          :label="`${job.id} - ${job.i18nTitle}`"
          :value="job.id"
        ></el-option>
      </el-select>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button class="footer-btn save-btn" @click="handleGenerate">
          <span class="label">{{ $t('common.btn.generate') }}</span>
          <i class="btn-icon iconfont icona-ResumeSummary"></i>
        </el-button>
      </div>
    </template>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {
    jobList: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      selectJobId: null
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    isLoading: {
      get () {
        return this.loading
      },
      set (val) {
        this.$emit('update:loading', val)
      }
    }
  },
  created () {
  },
  methods: {
    handleGenerate () {
      if (!this.selectJobId) {
        return
      }
      this.$emit('generateAIRecommendation', this.selectJobId)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.ai-comparison-select-job-dialog {
  .select-job-content {
    display: flex;
    align-items: center;
    .job-select {
      flex: 1;
      margin-left: 40px;
    }
  }
  .dialog-footer {

    .save-btn {
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;
      .label {
        vertical-align: middle;
      }
      .btn-icon {
        margin-left: 4px;
        font-size: 18px;
        vertical-align: middle;
      }
    }
  }
}
</style>
